import { ENVIRONMENT } from "./environment"

const config = {
	DEVELOPMENT: {
		url: 'https://dev.frankwatching.com/api/search/devfrankwatchingcomwp-1/post/_search'
	},
	ACCEPTANCE: {
		url: 'https://acc.frankwatching.com/api/search/accfrankwatchingcomwp-1/post/_search'
	},
	PRODUCTION: {
		url: 'https://www.frankwatching.com/api/search/frankwatchingcomwp-1/post/_search'
	}
};

export const elasticsearch = config[ENVIRONMENT];


// WEBPACK FOOTER //
// ./src/config/elasticsearch.js